import { lsGet, lsSet } from './storage';

/* Тема (P1): как в системе, светлая, тёмная. Применяется через html[data-theme].
   Выбор хранится в настройках клиента на сервере и копией на устройстве —
   чтобы тема была правильной с первого кадра, ещё до ответа API. */

export type Theme = 'system' | 'light' | 'dark';
export const THEMES: [Theme, string][] = [
  ['system', 'Как в системе'],
  ['light', 'Светлая'],
  ['dark', 'Тёмная'],
];

const mq = typeof matchMedia === 'function' ? matchMedia('(prefers-color-scheme: dark)') : null;
export const getTheme = () => lsGet<Theme>('theme', 'system');
export const isDark = () => {
  const t = getTheme();
  return t === 'dark' || (t === 'system' && !!mq?.matches);
};
/** Цвет страницы — для полос браузера (Safari и Chrome красят их в цвет страницы) */
export const pageColor = () => (isDark() ? '#121110' : '#F7F3EF');

let barOverride: string | null = null;
function paintBar() {
  const m = document.querySelector('meta[name=theme-color]') as HTMLMetaElement | null;
  if (m) m.content = barOverride || pageColor();
}
/** Заставка красит полосы в оранжевый, остальные экраны — в цвет страницы */
export function setBarColor(c: string | null) {
  barOverride = c;
  paintBar();
}

export function applyTheme(t?: Theme) {
  if (t) lsSet('theme', t);
  document.documentElement.dataset.theme = isDark() ? 'dark' : 'light';
  paintBar();
}

mq?.addEventListener?.('change', () => {
  if (getTheme() === 'system') applyTheme();
});
